module.exports = __webpack_public_path__ + "img/38_fineStaff_zhh.52853c67.png";